var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTriangles(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 64,
    viewBox: "0 0 69 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.89568e-06 7.50048L4.50001 -2.47123e-05L9 7.50048L4.89568e-06 7.50048ZM3.67176e-06 21.5005L4.5 14L9 21.5005L3.67176e-06 21.5005ZM15 21.5005L19.5 14L24 21.5005L15 21.5005ZM2.44784e-06 35.5005L4.5 28L9 35.5005L2.44784e-06 35.5005ZM15 35.5005L19.5 28L24 35.5005L15 35.5005ZM30 35.5005L34.5 28L39 35.5005L30 35.5005ZM1.22392e-06 49.5005L4.5 42L9 49.5005L1.22392e-06 49.5005ZM15 49.5005L19.5 42L24 49.5005L15 49.5005ZM30 49.5005L34.5 42L39 49.5005L30 49.5005ZM45 49.5005L49.5 42L54 49.5005L45 49.5005ZM0 63.5005L4.5 56L9 63.5005L0 63.5005ZM15 63.5005L19.5 56L24 63.5005L15 63.5005ZM30 63.5005L34.5 56L39 63.5005L30 63.5005ZM45 63.5005L49.5 56L54 63.5005L45 63.5005ZM60 63.5005L64.5 56L69 63.5005L60 63.5005Z",
    fill: "#4F7FFF",
    fillOpacity: 0.2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTriangles);
export default __webpack_public_path__ + "static/media/triangles.90121d57e34b76cb752d5857f64b91e5.svg";
export { ForwardRef as ReactComponent };